var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEnvelopeClosed = function SvgEnvelopeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4a4 4 0 0 0-4 4v8.5a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4Zm2 12.5a2 2 0 0 1-.28 1L16 8.32l5.76-5.24A2 2 0 0 1 22 4ZM12 9.25 4 2h16ZM2 12.5V4a2 2 0 0 1 .24-.92L8 8.31l-5.72 5.2A2 2 0 0 1 2 12.5Zm7.48-2.83 1.84 1.68a1 1 0 0 0 1.35 0l1.84-1.68 5.32 4.83H4.17Z"
  })));
};
export default SvgEnvelopeClosed;